import React from "react";
import { Typography, Button, Container, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

const HomePage = () => {
  const navigate = useNavigate();

  const handleSignUpNavigation = () => {
    navigate("/signUp");
  };
  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Hero Section */}
      <Container
        maxWidth="xl"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          py: 8,
          flexDirection: { xs: "column", md: "row" },
          gap: 4,
        }}
      >
        {/* Left Content */}
        <Box
          sx={{
            flex: "1 1 60%",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              pb: { xs: 10, md: 6 },
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Neuemontreal, sans-serif",
                fontSize: { xs: "16px", md: "21.3333px" },
                fontWeight: 500,
                lineHeight: { xs: "24px", md: "34.1333px" },
                color: "rgb(47, 106, 98)",
                mb: 3,
                cursor: "pointer",
              }}
              onClick={handleSignUpNavigation}
            >
              TRY IT NOW
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Neuemontreal, sans-serif",
                fontSize: { xs: "48px", md: "106.667px" },
                fontWeight: 500,
                lineHeight: { xs: "56px", md: "117.333px" },
                color: "rgb(0, 0, 0)",
                mb: 3,
              }}
            >
              Change the way you use your money
            </Typography>
            <Box sx={{ pt: 15 }}></Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "Neuemontreal, sans-serif",
                  fontSize: { xs: "18px", md: "26.6667px" },
                  fontWeight: 400,
                  lineHeight: { xs: "28px", md: "40px" },
                  color: "rgb(84, 96, 120)",
                  mb: 3,
                }}
              >
                From your everyday spending, to planning for your future with
                savings and investments, Ascone helps you get more from your
                money.
              </Typography>
            </Box>

            <Box display="flex" justifyContent="space-between" width="100%">
              {/* Button */}
              <Button
                variant="contained"
                size="large"
                sx={{
                  maxWidth: "250px",
                  backgroundColor: "#193C35",
                  color: "white",
                  borderRadius: "50px",
                  padding: { xs: "15px 20px", md: "30px 40px" },
                  fontSize: { xs: "18px", md: "24px" },
                  fontWeight: 400,
                  lineHeight: "28.8px",
                  "&:hover": {
                    backgroundColor: "#193C35",
                  },
                }}
                onClick={handleSignUpNavigation}
              >
                Get Started Now
              </Button>

              {/* Star Rating Section */}
              <Box display="flex" flexDirection="column" alignItems="center">
                {/* 5-Star Icons */}
                <Box display="flex" alignItems="center">
                  {Array(5)
                    .fill()
                    .map((_, i) => (
                      <Typography
                        key={i}
                        sx={{
                          color: "#FFC107",
                          fontSize: "1.5rem",
                          display: "flex",
                        }}
                      >
                        ★
                      </Typography>
                    ))}
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "black",
                      fontSize: { xs: "16px", md: "21.3333px" },
                      lineHeight: { xs: "24px", md: "32px" },
                      ml: 0.5,
                    }}
                  >
                    5.0
                  </Typography>
                </Box>

                {/* Review Text */}
                <Typography
                  sx={{
                    fontSize: { xs: "16px", md: "21.3333px" },
                    fontWeight: 400,
                    lineHeight: { xs: "24px", md: "32px" },
                    color: "rgb(84, 96, 120)",
                    ml: 1,
                  }}
                >
                  from 120+{" "}
                  <Box
                    component="a"
                    href="#"
                    sx={{
                      textDecoration: "underline",
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    reviews
                  </Box>
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Right Content - Mockup Image */}
        <Box
          sx={{
            flex: "1 1 40%",
            maxWidth: { xs: "100%", md: "40%" },
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            height: "auto",
          }}
        >
          <Box
            component="img"
            src="assets/drawing.png"
            alt="mockup"
            sx={{
              width: "100%",
              objectFit: "cover",
              clipPath: "inset(10px 10px 10px 10px)",
            }}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default HomePage;
